export default __webpack_public_path__ + "static/media/ISO360.3118bca919d2b5f95fbd135986d06b2b.webp";